<template>
    <ContainerContent
        class="mb-16"
        max-class="max-w-sm-ceil"
        outer-container
    >
        <v-row>
            <v-col>
                <h1 class="page-title">Contact Us</h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <p>To check the status of an existing order, please visit our <NuxtLink to="/order-status">Order Status</NuxtLink> page.</p>
                <p>To submit a warranty claim for a broken or defective item, please visit our <NuxtLink to="/support/warranty">Warranty Claim</NuxtLink> page.</p>
                <p>Please visit our <NuxtLink to="/faq">Frequently Asked Questions</NuxtLink> page for immediate answers to most commonly asked questions.</p>
                <p>We only accept orders placed through <NuxtLink to="/">{{ domainNameTitle }}</NuxtLink> and cannot take orders over the phone.</p>
                <ContactForm
                    :from-name="fromName"
                    :from-email="fromEmail"
                    :selected-recipient="selectedRecipient"
                    :selected-subject="selectedSubject"
                ></ContactForm>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-text
                        class="text-body-1 text-center text-sm-start"
                    >
                        <v-row>
                            <v-col cols="12" sm="4">
                                <h3 class="mb-2">Customer Service</h3>
                                <div class="pb-1">Call / Text</div>
                                <a class="d-block" :href="`tel:${mainContactPhoneNumber}`">
                                    {{ mainContactPhoneNumberFormatted || mainContactPhoneNumber }}
                                </a>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <h3 class="mb-2">Accounting</h3>
                                <div class="pb-1">Call / Text</div>
                                <a class="d-block" href="tel:+13105038901">
                                    +1 (310) 503-8901
                                </a>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <div v-if="address">
                                    <h3 class="mb-2">Address</h3>
                                    <a class="d-block" :href="addressMapUrl" target="_blank">
                                        {{ address.streetAddress }}
                                        <br />
                                        {{ address.city }} {{ address.countryArea }} {{ address.postalCode }}
                                    </a>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </ContainerContent>
</template>

<script lang="ts" setup>
    import ContactForm from '~/components/contact/ContactForm/ContactForm.vue';
    import { useUser, useAddressesUtils } from '~/composables';
    import ContainerContent from '~/components/ContainerContent/ContainerContent.vue';
    import { getSingleParam } from 'x1-base/utils';

    definePageMeta({
        scrollToTop: true,
        alias: [
            '/support/contact'
        ]
    });

    const ctx = useNuxtApp();
    const $config = useRuntimeConfig();
    const { getAddressMapUrl } = useAddressesUtils();
    const brandTitle = $config.public.brand.title;
    const domainNameTitle = ctx.$config.public.brand.domainNameTitle;
    const mainContactEmailAddress = ctx.$config.public.brand.mainContactEmailAddress;
    const mainContactPhoneNumber = ctx.$config.public.brand.mainContactPhoneNumber;
    const mainContactPhoneNumberFormatted = ctx.$config.public.brand.mainContactPhoneNumberFormatted;
    const companyObj = ctx.$config.public.brand.company;
    const address = companyObj?.address;
    const addressMapUrl = getAddressMapUrl(companyObj) ?? undefined;

    const route = useRoute();
    const useUserObj = useUser();

    const fromName = computed(() => {
        const user = useUserObj.userObj.value;
        return user ? `${user.firstName} ${user.lastName}` : '';
    });
    const fromEmail = ref(useUserObj.userObj.value?.email ?? '');
    const selectedRecipient = ref(getSingleParam(route.query, 'to') ?? null);
    const selectedSubject = ref(getSingleParam(route.query, 'subject') ?? null);

    useHead({
        title: `Contact | ${brandTitle}`,
        meta: [
            {
                name: 'description',
                content: 'The Best Trust StringKing'
            }
        ]
    });
</script>

<style lang="scss" scoped></style>
